export default function number(value) {
  return (/^\d+$/.test(value)
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/utils/validate/number.js
// module id = 265
// module chunks = 80